var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "l-popper",
        {
          attrs: {
            trigger: "clickToOpen",
            options: {
              placement: "auto",
              modifiers: { offset: { offset: "0,10px" } },
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpenDownloadTooltip,
                  expression: "isOpenDownloadTooltip",
                },
              ],
              staticClass: "popper",
            },
            [
              _vm.isOpenTooltip
                ? _c("SubscriptionTooltip")
                : _c("DownloadDesign", {
                    attrs: {
                      sku: _vm.sku,
                      name: _vm.name,
                      isPurchased: _vm.isPurchased == true,
                      isCollection: _vm.isCollection,
                      designtype: _vm.designtype,
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "l-button",
            {
              attrs: { slot: "reference", type: "list-entity-button" },
              nativeOn: {
                click: function ($event) {
                  return _vm.onClick()
                },
              },
              slot: "reference",
            },
            [
              _c("img", {
                attrs: {
                  src: "/static/creativate-icons/download.svg",
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }